import React, { useEffect, useState } from 'react';
import { EventPayout, EventDate, SetLoading } from '../SiteClasses';
import { Modal, Items, Icon, Message, Button, Table, Toast, Header } from 'react-frontier';
import { firstBy } from 'thenby';
import { addCommas } from '../SiteUtil';
import { useUser } from '../hooks';
import API from '../API';
import moment from 'moment';

interface PayoutWorker{
	worker_id: number, 
	title_name: string, 
	payout_amount: number, 
	worker_name: string, 
	has_active_payout: boolean
}

interface PayoutModalProps{
	open: boolean;
	onClose: () => void;
	onCreate: (payout: EventPayout) => void;
	date_id: number;
}

var PayoutModal = (props: PayoutModalProps)=>{
	var { user } = useUser();
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [workers, setWorkers] = useState<PayoutWorker []>(null);
	var [event, setEvent] = useState<EventDate>(null);
	var [selectedWorkers, setSelectedWorkers] = useState<number []>([]);

	useEffect(()=>{
		if(!props.open || !!workers) return;
		API.eventPayoutPreparation(props.date_id).then(res=>{
			if (res.error) return setModalPrompts([res.message]);
			setWorkers(res.data.workers);
			setEvent(res.data.event);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado cargando los trabajadores (LCL-1)']);
		})
	}, [props.open]);

	var submit = (setLoading: SetLoading)=>{
		if(selectedWorkers.length === 0) return setModalPrompts(['Selecciona al menos un trabajador']);

      setLoading(true);
		API.eventPayoutCreation(props.date_id, selectedWorkers).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Liquidación generada!');
			var newPayout: EventPayout = {
				payout_id: res.data,
				date_created: moment().unix(),
				user_creator: null,
				user_creator_name: (user.first_name + ' ' +user.last_name),
				total_amount: total,
				paid_amount: 0,
				pending_amount: total,
				worker_count: selectedWorkers.length,
				paid_count: 0,
				completed: false,
			};
			props.onCreate(newPayout);
		}).catch(err=>{
			setModalPrompts(['Hubo un error inesperado generando la liquidación (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		});
   }

	var total = workers?.filter(w => selectedWorkers.includes(w.worker_id))?.reduce((sum, w) => sum + w.payout_amount, 0) || 0;
	var activePayoutCount = workers?.filter(w => selectedWorkers.includes(w.worker_id))?.filter(w => w.has_active_payout)?.length || 0;

	if(!workers || !event) return null;

	return <Modal open={props.open} size='tiny' onClose={props.onClose}>
		<Modal.Header>Aprobar pagos</Modal.Header>
		<Modal.Content>
			<Table
				fitted
				striped
				details
				data={[
					['Nombre', event.event_name],
					['Ciudad', event.city],
					['Promotor', event.promoter],
					['Trabajadores' , selectedWorkers.length],
					['Total', '$' + addCommas(total)]
				]}
			/>
			<Items
				style={{ overflow: 'auto', maxHeight: 300, overflowY: 'scroll' }}
				toggle
				selectable
				data={workers?.sort(firstBy('has_active_payout', 'desc'))}
				selected={selectedWorkers}
				onToggle={setSelectedWorkers}
				valueExtractor={w=>w.worker_id}
				render={w=>{
					return <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						<Icon name='user'/>
						<div style={{ width: '50%'}}>
							<div style={{ fontSize: 14, fontWeight: 'bold', color: w.has_active_payout ? 'brown' : 'black' }}>{w.worker_name}</div>
							<div style={{ fontSize: 12, color: 'gray' }}>{w.title_name || 'Otro'}</div>
						</div>
						<div style={{ width: '50%' , textAlign:'end'}}>
							<div style={{ fontSize: 14, fontWeight: 'bold'}}>{'$' + addCommas(w.payout_amount)}</div>
							{w.has_active_payout ? <div style={{ fontSize: 12, color: 'gray' }}>Liquidado anteriormente</div> : null}
						</div>
					</div>
				}}
			/>
			{activePayoutCount > 0 ? <Message type='warning' text={`${activePayoutCount} trabajadores ya han sido liquidados anteriormente`} size='small' centered/> : null}
			<Message type="error" list={modalPrompts} />
		</Modal.Content>
		<Modal.Actions>
			<Button text='Cerrar' onClick={props.onClose}/>
			<Button text='Aprobar' color='black' onClick={submit}/>
		</Modal.Actions>
	</Modal>
}

export default PayoutModal;